/**
 * Ops GraphQL mutations for location-level integrations.
 *
 * These target /graphql/ops (not the public schema). The merged schema covers
 * the ops mutations, so result and variable types are inferred by codegen.
 */

import { graphql } from 'app/generated/gql'

// ─── Result type ──────────────────────────────────────────────────────────────

export type IntegrationSaveResult = {
  success: boolean
  error?: string
}

// ─── Mutations ────────────────────────────────────────────────────────────────

export const SAVE_GRAVITY_FORMS_INTEGRATION = graphql(`
  mutation SaveGravityFormsIntegration($locationId: ID!, $gravityFormsKey: String!, $isNew: Boolean) {
    saveGravityFormsIntegration(locationId: $locationId, gravityFormsKey: $gravityFormsKey, isNew: $isNew) {
      success
      error
    }
  }
`)

export const SAVE_WEBFLOW_FORMS_INTEGRATION = graphql(`
  mutation SaveWebflowFormsIntegration($locationId: ID!, $webflowFormsKey: String!, $isNew: Boolean) {
    saveWebflowFormsIntegration(locationId: $locationId, webflowFormsKey: $webflowFormsKey, isNew: $isNew) {
      success
      error
    }
  }
`)

export const SAVE_FACEBOOK_ADS_INTEGRATION = graphql(`
  mutation SaveFacebookAdsIntegration(
    $locationId: ID!
    $account: String
    $campaigns: [FacebookAdsCampaignInput!]
    $isNew: Boolean
  ) {
    saveFacebookAdsIntegration(locationId: $locationId, account: $account, campaigns: $campaigns, isNew: $isNew) {
      success
      error
    }
  }
`)

export const SAVE_CALLRAIL_INTEGRATION = graphql(`
  mutation SaveCallRailIntegration($locationId: ID!, $companyId: String!, $backfillStartDate: String, $isNew: Boolean) {
    saveCallRailIntegration(
      locationId: $locationId
      companyId: $companyId
      backfillStartDate: $backfillStartDate
      isNew: $isNew
    ) {
      success
      error
    }
  }
`)

export const SAVE_CARESTACK_INTEGRATION = graphql(`
  mutation SaveCarestackIntegration($locationId: ID!, $selection: String!) {
    saveCarestackIntegration(locationId: $locationId, selection: $selection) {
      success
      error
    }
  }
`)

export const SAVE_ASCEND_INTEGRATION = graphql(`
  mutation SaveAscendIntegration($locationId: ID!, $ascendLocationId: String!) {
    saveAscendIntegration(locationId: $locationId, ascendLocationId: $ascendLocationId) {
      success
      error
    }
  }
`)

export const SAVE_SIKKA_INTEGRATION = graphql(`
  mutation SaveSikkaIntegration($locationId: ID!, $selection: String!) {
    saveSikkaIntegration(locationId: $locationId, selection: $selection) {
      success
      error
    }
  }
`)

export const SAVE_RINGCENTRAL_INTEGRATION = graphql(`
  mutation SaveRingCentralIntegration($locationId: ID!, $phoneNumbers: [String!]!, $isNew: Boolean) {
    saveRingCentralIntegration(locationId: $locationId, phoneNumbers: $phoneNumbers, isNew: $isNew) {
      success
      error
    }
  }
`)

export const SAVE_TWILIO_INTEGRATION = graphql(`
  mutation SaveTwilioIntegration(
    $locationId: ID!
    $poolSelection: [TwilioNumberInput!]
    $aiSelection: String
    $aiTestingSelection: String
    $isNew: Boolean
  ) {
    saveTwilioIntegration(
      locationId: $locationId
      poolSelection: $poolSelection
      aiSelection: $aiSelection
      aiTestingSelection: $aiTestingSelection
      isNew: $isNew
    ) {
      success
      error
    }
  }
`)

export const SAVE_KOLLA_INTEGRATION = graphql(`
  mutation SaveKollaIntegration(
    $locationId: ID!
    $kollaConsumerId: String!
    $kollaConnectorId: String
    $kollaPracticeId: String
  ) {
    saveKollaIntegration(
      locationId: $locationId
      kollaConsumerId: $kollaConsumerId
      kollaConnectorId: $kollaConnectorId
      kollaPracticeId: $kollaPracticeId
    ) {
      success
      error
    }
  }
`)

export const REMOVE_LOCATION_INTEGRATION = graphql(`
  mutation RemoveLocationIntegration($locationId: ID!, $integration: String!) {
    removeLocationIntegration(locationId: $locationId, integration: $integration) {
      success
      error
    }
  }
`)
